import React, { useEffect, useState } from "react";
import { callApi } from "../../services/ApiServices";
import CommonLoader from "../common/CommonLoader";
import { useGlobalStates } from "../../utlis/ClubsContext";
import CommonPagination from "../common/CommonPagination";
import { renderImages } from "../../utlis/function";
import toast from "react-hot-toast";
import Lottie from "lottie-react";
import { ImagePath } from "../common/ImagePath";
import { useNavigate } from "react-router-dom";
import { UserRole } from "../../utlis/constant";

const ClubsResortListing = ({ onClubSelect, onAddClub }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [clubsData, setClubsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const { userRole, setClubId } = useGlobalStates();
  const limit = 10;

  useEffect(() => {
    fetchClubListing(currentPage, limit);
  }, []);

  const fetchClubListing = async (page, limit, search) => {
    const trimmedSearch = search?.trim();
    if (search && !trimmedSearch) {
      return;
    }
    if (!search) {
      setLoading(true);
    }
    try {
      let ApiUrl = `club/list?page=${page}&limit=${limit}`;
      if (trimmedSearch) {
        ApiUrl += `&keyword=${trimmedSearch}`;
      }

      const response = await callApi({
        method: "get",
        url: ApiUrl,
      });
      console.log("responseListing", response);
      setClubsData(response.data);
      const totalitems = response?.pagination?.total;
      const totalPages = Math.ceil(totalitems / limit);
      setTotalCount(totalPages);
    } catch (error) {
      console.log("error while fetching clubListing", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (e) => {
    setCurrentPage(e);
    fetchClubListing(e, limit, searchQuery);
  };

  const toggleStatus = async (e, club) => {
    e.stopPropagation();
    const newStatus = club.status === "active" ? "inactive" : "active";
    setLoading(true);
    try {
      const response = await callApi({
        method: "put",
        url: `club/change-status/${club.id}`,
        data: {
          status: newStatus,
        },
      });
      if (response.status === 200) {
        setClubsData((prev) =>
          prev.map((item) =>
            item.id === club.id ? { ...item, status: newStatus } : item,
          ),
        );
        toast.success(response?.message, { id: "toggleStatusToast" });
      }
    } catch (error) {
      console.log("error while toggling status", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
        {/* Search Bar */}
        <div className="relative w-full sm:w-auto sm:min-w-[320px]">
          <svg
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 text-textcolor"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19 19L14.65 14.65"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <input
            type="search"
            placeholder="Search by club name, location..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
              fetchClubListing(currentPage, limit, e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === " " && searchQuery?.length === 0) {
                e.preventDefault();
              }
            }}
            className="w-full pl-12 pr-4 py-3 bg-white rounded-lg text-base font-normal text-black placeholder:text-textcolor border border-gray-200 focus:outline-none focus:border-primary transition-colors"
          />
        </div>

        {/* Add Club Button */}
        {userRole !== UserRole.Viewer && (
          <button
            onClick={onAddClub}
            className="w-full sm:w-auto flex items-center justify-center gap-2 bg-primary hover:bg-hover text-white font-medium text-base px-6 py-3 rounded-lg transition-colors"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 4V16M4 10H16"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Add Club
          </button>
        )}
      </div>

      {/* Table */}
      {loading && <CommonLoader fullScreen />}
      <div className="bg-white rounded-xl main-shadow overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-white border-b border-gray-200">
              <tr>
                <th className="text-left px-6 py-3 text-base font-medium text-black tracking-[0] leading-[normal]">
                  Club Name
                </th>
                <th className="text-left px-6 py-3 text-base font-medium text-black tracking-[0] leading-[normal]">
                  Location
                </th>
                <th className="text-left px-6 py-3 text-base font-medium text-black tracking-[0] leading-[normal]">
                  Displays
                </th>
                <th className="text-left px-6 py-3 text-base font-medium text-black tracking-[0] leading-[normal]">
                  Monthly Visits
                </th>
                <th className="text-left px-6 py-3 text-base font-medium text-black tracking-[0] leading-[normal]">
                  Active Ads
                </th>
                <th className="text-left px-6 py-3 text-base font-medium text-black tracking-[0] leading-[normal]">
                  Status
                </th>
                <th className="text-left px-6 py-3 text-base font-medium text-black tracking-[0] leading-[normal]">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {clubsData?.length === 0 ? (
                <tr>
                  <td colSpan={7} className="px-6 py-10 text-center">
                    <div className="flex justify-center items-center">
                      <img
                        src={ImagePath?.NoDataFound}
                        alt="No Data Found"
                        style={{ width: 70, height: 70 }}
                      />
                    </div>
                    <p className="text-xl mt-2">No data found</p>
                  </td>
                </tr>
              ) : (
                clubsData?.map((club, index) => (
                  <tr
                    key={club.id}
                    className="border-b border-gray-100 hover:bg-lightbg/30 transition-colors "
                    // onClick={() => onClubSelect && onClubSelect(club)}
                  >
                    {console.log("clubData", club)}
                    <td className="px-6 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex-shrink-0">
                          <img
                            src={club?.clubLogoFile?.fileUrl}
                            alt={club?.name}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <span className="text-sm font-normal text-textcolor tracking-[0] leading-[normal] line-clamp-1 max-w-[200px]">
                          {club?.clubName}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor tracking-[0] leading-[normal]">
                      {club?.addresses?.length > 0
                        ? `${club.addresses[0]?.contactCity ?? ""}, ${club.addresses[0]?.contactCountry ?? ""}`
                        : "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor tracking-[0] leading-[normal]">
                      {club?.totalScreensCount || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor tracking-[0] leading-[normal]">
                      {club?.monthlyImpressions || "-"}
                    </td>
                    <td className="px-6 py-3 text-sm font-normal text-textcolor tracking-[0] leading-[normal]">
                      {club?.active_screens || "-"}
                    </td>
                    <td className="px-6 py-3">
                      <button
                        onClick={(e) => toggleStatus(e, club)}
                        disabled={userRole === UserRole.Viewer}
                        className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors focus:outline-none ${club.status === "active" ? "bg-[#4CAF50]" : "bg-gray-300"}
                         ${userRole === UserRole.Viewer ? "cursor-not-allowed opacity-50" : "cursor-pointer"}`}
                      >
                        <span
                          className={`inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${
                            club.status === "active"
                              ? "translate-x-5"
                              : "translate-x-1"
                          }`}
                        />
                      </button>
                    </td>
                    <td className="px-6 py-3">
                      <button
                        onClick={() => {
                          // onClubSelect && onClubSelect(club)
                          console.log("cludListingId", club?.id);
                          setClubId(club);
                          navigate(`/clubs-details/${club?.id}`);
                        }}
                        className="p-1 hover:bg-gray-100 rounded transition-colors cursor-pointer"
                      >
                        {/* <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="10" cy="4" r="1.5" fill="#4C4C4C" />
                        <circle cx="10" cy="10" r="1.5" fill="#4C4C4C" />
                        <circle cx="10" cy="16" r="1.5" fill="#4C4C4C" />
                      </svg> */}

                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z" />
                          <circle cx="12" cy="12" r="3" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <CommonPagination
        pageCount={totalCount}
        currentPage={currentPage}
        onPageChange={(e) => handlePageChange(e)}
      />
    </div>
  );
};

export default ClubsResortListing;
